import { CanDeactivateFn } from '@angular/router';
import { ReleasePageComponent } from './release-page.component';

export const canDeactivateReleasePage: CanDeactivateFn<ReleasePageComponent> = (component) =>
  component.confirmDeactivate();
